"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _hooks = require("../../../../hooks");

var _components = require("../../../../components");

var _Hours = require("../../Hours");

var _LocationInfoModule = _interopRequireDefault(require("./LocationInfo.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var LocationInfo = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var cellType = _ref.cellType,
      label = _ref.label,
      open = _ref.open,
      close = _ref.close,
      name = _ref.name,
      phone = _ref.phone,
      address = _ref.address,
      dineInOpen = _ref.dineInOpen,
      dineInClose = _ref.dineInClose,
      displayHour = _ref.displayHour,
      displayHourDineIn = _ref.displayHourDineIn;

  var _useTemplate$useCell = _hooks.useTemplate.useCell(cellType),
      views = _useTemplate$useCell.views,
      labelTextStyles = _useTemplate$useCell.labelTextStyles;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _LocationInfoModule["default"]["location-info-card"]
  }, /*#__PURE__*/_react["default"].createElement(_components.View, {
    type: views.secondary,
    className: _LocationInfoModule["default"]["location-title"],
    direction: "column"
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.primary,
    role: "heading",
    "aria-level": "1",
    "aria-label": name
  }, name)), /*#__PURE__*/_react["default"].createElement(_components.View, {
    type: views.background,
    className: _LocationInfoModule["default"]["location-info"],
    direction: "column"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.secondary
  }, phone)), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.secondary
  }, address)), /*#__PURE__*/_react["default"].createElement(_Hours.Hours, {
    labelThemeType: labelTextStyles.secondary,
    label: label,
    open: open,
    close: close,
    displayHour: displayHour
  }), /*#__PURE__*/_react["default"].createElement(_Hours.Hours, {
    labelThemeType: labelTextStyles.secondary,
    label: "Store Hours",
    open: dineInOpen,
    close: dineInClose,
    displayHour: displayHourDineIn
  })));
});

var _default = LocationInfo;
exports["default"] = _default;